"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';

const Panel = forwardRef(
  ({ className, children, ...props }, ref) => {
    const { panel } = dropdownRecipe();
    return /* @__PURE__ */ jsx("div", { className: clsx(panel, className), ref, ...props, children });
  }
);

export { Panel };
